import React, { Component } from 'react';

import TextField from './forms/TextField';

export default class ShareableLink extends Component {
  highlight = (event) => {
    event.target.select();
  };

  render() {
    const { name, title, url } = this.props;
    return (
      <TextField
        name={name}
        title={title}
        data={{ [name]: url }}
        onClick={this.highlight}
        readOnly
      />
    );
  }
}
